import React from 'react';
import OverlayView from './Overlay/OverlayView';
import { Spinner } from 'dibs-elements/exports/Spinner';
import styles from './loadingComponent.scss';

const LoadingComponent = () => (
    <OverlayView isTransparent isAboveOverlay>
        <Spinner dark containerClass={styles.centeredDiv} />
    </OverlayView>
);

export default LoadingComponent;
